export const orderReplacementCard = {
    enableAddContactModal: true,
};
